import Party from "@/models/party";
import Activity from "@/models/activity";
import utils from "@/services/utils";

export default class SchedulerEvent {
    public id?: number;
    public patient: Party;
    public therapist: Party;
    public activity: Activity;
    public description?: string;
    public status: string;
    public paymentStatus: string;
    public dateFrom: string;
    public timeFrom: string;
    public duration: number;


    constructor({id, patient, therapist, activity, description, status, paymentStatus, dateFrom, timeFrom, duration = 60}: any) {
        this.id = id;
        this.patient = patient;
        this.therapist = therapist;
        this.activity = activity;
        this.description = description;
        this.status = status || 'CONFIRMED';
        this.paymentStatus = paymentStatus || 'UNPAID';
        this.dateFrom = dateFrom;
        this.timeFrom = timeFrom;
        this.duration = duration;
    }

    public get start() {
        return `${this.dateFrom} ${this.timeFrom !== undefined ? this.timeFrom : '00:00'}`;
    }
    public set start(date:String) {
        let pd = this.dateFrom;
        let pt = this.timeFrom;
        let strings = date.split(' ');
        this.dateFrom = strings[0]||pd
        this.timeFrom = strings[1]||pt
    }

    public set end(date:String) {
        // let pd = this.dateFrom;
        // let pt = this.timeFrom;
        // let strings = date.split(' ');
        // this.dateFrom = strings[0]||pd
        // this.timeFrom = strings[1]||pt

    }

    public get end() {
        return new Date(
            new Date(`${this.start.replace(" ", "T")}:00.000Z`)
                .getTime() + (1000 * 60 * this.duration)).toISOString()
            .replace("T", " ")
            .replace(":00.000Z", "");
    }

    public get name() {
        return (utils.isNotNull(this.activity) && utils.isNotNull(this.therapist)) ? `${this.activity.name} - ${this.therapist.surname}` : ''
    }
}

export class WriteSchedulerEvent {
    public id?: number;
    public therapistId: number;
    public patientId: number;
    public activityId: number;
    public description?: string;
    public status: string;
    public paymentStatus: string;
    public dateFrom?: string;
    public timeFrom?: string;
    public duration?: number;


    constructor(id: number | undefined, therapistId: number, patientId: number, activityId: number, description: string | undefined, status: string | 'CONFIRMED', paymentStatus: string | 'UNPAID', dateFrom: string, timeFrom: string, duration: number) {
        this.id = id;
        this.therapistId = therapistId;
        this.patientId = patientId;
        this.activityId = activityId;
        this.description = description;
        this.status = status;
        this.paymentStatus = paymentStatus;
        this.dateFrom = dateFrom;
        this.timeFrom = timeFrom;
        this.duration = duration;
    }
}

export class TherapyUnit {
    public id?: number;
    public activity?: Activity
    public weeklyNumber?: number;
    public duration?: number;
    public preferredTherapist?: number;

    constructor({id, activity, weeklyNumber, duration, preferredTherapist}: any) {
        this.id = id;
        this.activity = activity;
        this.weeklyNumber = weeklyNumber;
        this.duration = duration
        this.preferredTherapist = preferredTherapist
    }
}
